define('AwaLabs.SummaryUpdates', [
    'SC.Configuration'
], function AwaLabsSummaryUpdates(
    Configuration
) {
    'use strict';

    return {
        mountToApp: function mountToApp(application) {
            var cart = application.getComponent('Cart');
            var checkout = application.getComponent('Checkout');
            if (cart) {
                cart.addToViewContextDefinition('Cart.Summary.View', 'estimatedLegend', 'string', function estimatedLegend() {
                    return Configuration.get('summaryUpdates.estimatedLegend');
                });
                cart.addToViewContextDefinition('Cart.Summary.View', 'estimatedLabel', 'boolean', function estimatedLabel() {
                    return Configuration.get('summaryUpdates.estimatedLabel');
                });
            }
            if (checkout) {
                checkout.addToViewContextDefinition('OrderWizard.Module.CartSummary', 'estimatedLegend', 'string', function estimatedLegend() {
                    return Configuration.get('summaryUpdates.estimatedLegend');
                });
                checkout.addToViewContextDefinition('OrderWizard.Module.CartSummary', 'estimatedLabel', 'boolean', function estimatedLabel() {
                    return Configuration.get('summaryUpdates.estimatedLabel');
                });
                checkout.addToViewContextDefinition('OrderWizard.Module.CartSummary', 'shippingLabel', 'boolean', function shippingLabel() {
                    return Configuration.get('summaryUpdates.shippingLabel') && Backbone.history.fragment.startsWith('shipping/address');
                });
                checkout.addToViewContextDefinition('OrderWizard.Module.CartSummary', 'shippingLegend', 'string', function shippingLegend() {
                    return Configuration.get('summaryUpdates.shippingLegend');
                });
            }
        }
    };
});
